var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('spinner-loader'),_vm._v(" "),(_vm.$store.state.loggingIn)?_c('login-confirm'):_vm._e(),_vm._v(" "),_c('site-nav'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }